import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { access, passage } from '../../../../model/access';
import moment from 'moment';

export interface IActions {
    loadAccesses: (user: string, date?: Date, dateTo?: Date) => Promise<Array<access>>;
    loadPassages: () => Promise<Array<passage>>;
    // loadContactAccesses: (sub: string) => Promise<access>;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadAccesses: (user: string, date?: Date, dateTo?: Date) => {

            console.log("load ACCESS PARAMETER:", user, date, dateTo);

            var pathApi = "/api/Access";

            if (user && user !== "" && date === null && dateTo === null) {
                pathApi = "/api/Access/" + user;
            }
            else if (user && user !== "" && date !== null && dateTo === null) {
                pathApi = "/api/Access/" + user + "/day/" + moment(date).format("YYYYMMDD");
            }
            else if (user && user !== "" && date !== null && dateTo !== null) {
                pathApi = "/api/Access/" + user + "/from/" + moment(date).format("YYYYMMDD") + "/to/" + moment(dateTo).format("YYYYMMDD");
            }
            else if (user === undefined && date !== null) {
                pathApi = "/api/Access/day/" + moment(date).format("YYYYMMDD");
            }
            else {
                return;
            }
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADACCESSES,
                    payload: invokeApi({
                        path: pathApi,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        loadPassages: () => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADPASSAGES,
                    payload: invokeApi({
                        path: "/api/Passages",
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
    }
}